// extracted by mini-css-extract-plugin
export default {"container":"LeadingContent-module__container--NoK8W","isSelectable":"LeadingContent-module__isSelectable--J9kYS"};